import React, { useReducer } from "react";
import { Panel } from "@radarly/models/panel";
import Context from "./context";
import reducer from "./reducer";

const INITIAL_STATE = [];

const Provider: React.FC<{ initialState?: Panel[] }> = ({
  children,
  initialState = INITIAL_STATE,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <Context.Provider value={{ state, dispatch }}>{children}</Context.Provider>
  );
};

export default Provider;
